import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "./sass/main.scss";
import VueToast from "vue-toast-notification";
import AxiosPlugin from "vue-axios-cors";
import VueMoment from "vue-moment";

// Localization
import { i18n } from "./locale/i18n";

Vue.use(VueToast);
Vue.use(AxiosPlugin);
Vue.use(VueMoment);
import "vue-toast-notification/dist/theme-sugar.css";

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
